/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file PostVaccineAntiHbsView.jsx
 * @author Daniel Aguirre
 * @description PostVaccineAntiHbs View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import { useHistory } from 'react-router';
import DashboardDoughnut from 'components/Charts/DashboardDoughnut';
import styleGuideColors from 'commons/styleGuideColors';
import useTruncateAndFormat from 'hook/useTruncateAndFormat';

/**
 * PostVaccineAntiHbs View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function PostVaccineAntiHbsView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState(null);

  const { getPostVaccineAntiHbs } = dashboardStaffActions;

  const onGetData = (_, resp) => {
    let data = [];
    const classifications = [
      {
        label: 'Si registra',
        color: styleGuideColors.baxterBrandTeal
      },

      {
        label: 'No registra',
        color: styleGuideColors.graphGreyStrokes
      }
    ];

    let total = 0;

    if (resp?.data) {
      resp.data.forEach(({ cantidad }) => {
        total += cantidad;
      });
      classifications.forEach(({ label, color }) => {
        const respElement = resp.data.find(
          ({ clasificacion }) => clasificacion === label
        );
        if (respElement) {
          const value = (respElement.cantidad * 100) / total;
          data = [
            ...data,
            {
              value: useTruncateAndFormat(value, 2),
              label,
              color,
              cantidad: respElement.cantidad
            }
          ];
        }
      });
      setChartData(data);
    }
  };

  useEffect(() => {
    getPostVaccineAntiHbs({ clinicId }, onGetData);
  }, [translate, clinicId]);

  const handleDetailClick = (index) => {
    const { label: classification, cantidad: totalItems } = chartData[index];
    history.push(
      `/main/dashboard-detail/post-vaccine-anti-hbs/${classification}/${totalItems}`
    );
  };

  return (
    <DashboardCard id="F11" loading={!chartData}>
      <DashboardDoughnut
        title={translate('dashboardStaff.postVaccineAntiHbs')}
        dataValues={chartData || []}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
PostVaccineAntiHbsView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getPostVaccineAntiHbs: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default PostVaccineAntiHbsView;
